<mat-toolbar class="p-0">

    <div fxFlex fxFill fxLayout="row" fxLayoutAlign="start center">

        <div fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">

            <button mat-icon-button class="navbar-toggle-button"
                    *ngIf="!hiddenNavbar && !rightNavbar" (click)="toggleSidebarOpen('navbar')" fxHide.gt-md>
                <mat-icon class="secondary-text">menu</mat-icon>

            </button>

            <div class="toolbar-separator" *ngIf="!hiddenNavbar && !rightNavbar" fxHide.gt-md></div>

        </div>

        <div class="" fxFlex="0 1 auto" fxLayout="row" fxLayoutAlign="start center">
        

            <button id="user_button" mat-button [matMenuTriggerFor]="notification"
                    class="user-button">
                <div fxLayout="row" fxLayoutAlign="center center">
                   <!--  <img class="avatar mr-0 mr-sm-16" src="assets/img/user.svg" alt="User's avatar">
                    <span class="username mr-12" fxHide fxShow.gt-sm>{{currentUser.user_nombre | slice: 0:30}} </span>
                    <mat-icon class="s-16" fxHide.xs>keyboard_arrow_down</mat-icon> -->
                    
                    <mat-icon matBadge="{{notificaciones.noRead}}" matBadgeColor="warn" *ngIf="notificaciones.noRead != 0" >notifications_active</mat-icon>
                    <mat-icon *ngIf="notificaciones.noRead == 0" >notifications</mat-icon>
                </div>
            </button>

            <mat-menu #notification="matMenu" class="panel-notification" [overlapTrigger]="false">

                <div class="container-menu">
                    <div class="header-menu">
                        <ng-container *ngIf="notificaciones.noRead > 1; else singleNotification">
                            Tiene {{notificaciones.noRead}} notificaciones sin leer
                        </ng-container>
                        <ng-template #singleNotification>
                            <ng-container *ngIf="notificaciones.noRead === 1; else noNotifications">
                                Tiene {{notificaciones.noRead}} notificación sin leer
                            </ng-container>
                        <ng-template #noNotifications>
                            No tienes notificaciones por leer
                        </ng-template>
                    </ng-template>

                    </div>

                    <hr>

                    <div class="notification" *ngFor="let n of notificaciones.list">
                        <ng-container *ngIf="n.READ_IT == 0">
                          <div class="icon-notification">
                            <mat-icon *ngIf="n.READ_IT == 0">email</mat-icon>
                            <mat-icon *ngIf="n.READ_IT == 1">drafts</mat-icon>
                          </div>
                          <div class="label-notification">{{n.CREATED_AT | date: 'dd/MM/yyyy'}} - <strong>{{n.TITLE}}</strong></div>
                        </ng-container>
                      </div>
                    <hr>
                    <div class="footer-notification">
                        <span (click)="goNotifications()">Ver todas las Notificaciones</span>
                    </div>
                </div>

          <!--       <button id="go_to_profile_button" mat-menu-item (click)="goProfile()">
                    <mat-icon>account_circle</mat-icon>
                    <span>Mi Perfil</span>
                </button> -->

               

            </mat-menu>
            <button id="user_button" mat-button [matMenuTriggerFor]="userMenu"
                    class="user-button" (click)="getUserActions()">
                <div fxLayout="row" fxLayoutAlign="center center">
                    <img class="avatar mr-0 mr-sm-16" [src]="profileImageUrl || 'assets/img/user.svg'">
                    <span class="username mr-12" fxHide fxShow.gt-sm>{{currentUser.user_nombre | slice: 0:30}} </span>
                    <mat-icon class="s-16" fxHide.xs>keyboard_arrow_down</mat-icon>
                </div>
            </button>

            <mat-menu #userMenu="matMenu"  [overlapTrigger]="false" >

                <button id="go_to_profile_button" *ngIf="actions?.detail_procurador_personal_info_profile" mat-menu-item (click)="goProfile()" >
                    <mat-icon>account_circle</mat-icon>
                    <span>Mi Perfil</span>
                </button>

                <!-- <button id="help_button"  mat-menu-item class="" disabled>
                    <mat-icon>help</mat-icon>
                    <span>Ayuda</span>
                </button> -->

                <button id="logout_button" mat-menu-item class="" (click)="logout()">
                    <mat-icon>exit_to_app</mat-icon>
                    <span>Salir</span>
                </button>

            </mat-menu>

            <div class="toolbar-separator" *ngIf="!hiddenNavbar && rightNavbar" fxHide fxShow.gt-xs></div>

            <button mat-icon-button class="navbar-toggle-button"
                    *ngIf="!hiddenNavbar && rightNavbar" (click)="toggleSidebarOpen('navbar')" fxHide.gt-md>
                <mat-icon class="secondary-text">menu</mat-icon>
            </button>

        </div>

    </div>

</mat-toolbar>
